import React, { useState } from 'react'
import { useMutation } from '@apollo/client'
import { useAuth } from 'src/utils/auth'
import FashionEnthusiastsBanner from '../../../../../../../public/assets/img/enthoumBg.svg'
import MobileFashionEnthusiastsBanner from '../../../../../../../public/assets/img/MobilefashionEnthem.svg'
import { WOMEN_SECTION_TEXT } from 'src/Helpers/Json/WomanCategoryList'
import { useRouter } from 'next/router'
import { fetchApplianceCategory } from 'src/store/slices/manageApplianceCategorySlice'
import { useAppDispatch } from 'src/store/store'
import AosAnimation from 'src/utils/AosAnimation'
import { useSelector } from 'react-redux'
import { fetchAllPeople } from 'src/store/slices/fetchAllPeopleSlice'
import SEND_FRIEND_REQUEST from 'src/graphql/mutations/sendFriendRequest'
import DECLINE_FRIEND_REQUEST from 'src/graphql/mutations/declineFriendRequest'
import { guestAccountDetailSlice } from 'src/store/slices/guestAccountDetailSlice'
import PeopleItem from 'src/components/StoreAndProductDetailModal/PeopleModal/PeopleItem'

export default function FashionEnthusiasts(props) {
  const { user } = useAuth()
  const router = useRouter()
  const dispatch = useAppDispatch()

  const peopleData = useSelector((state: any) => state?.peopleData)
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(15)

  const [sendFriendRequest] = useMutation(SEND_FRIEND_REQUEST, {
    onCompleted: () => {
      dispatch(fetchAllPeople({ limit: limit, page: page, type: 'ALL_PEOPLE', prevPost: [] }))
    },
    onError: (error) => {
      console.log(error)
    },
  })

  const [declineFriendRequest] = useMutation(DECLINE_FRIEND_REQUEST, {
    onCompleted: () => {
      dispatch(fetchAllPeople({ limit: limit, page: page, type: 'ALL_PEOPLE', prevPost: [] }))
    },
    onError: (error) => console.log(error),
  })

  const declineFriendRequestCall = (people) => {
    if (user) {
      declineFriendRequest({
        variables: { user_id: user?.id, friend_id: people?.id },
      })
    } else {
      handleRedirect()
    }
  }

  const handleRedirect = () => {
    dispatch(
      guestAccountDetailSlice({
        modal: 'authModal',
        isOpen: true,
        id: {
          media: 'https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4',
          modalFor: 'login',
          startWith: 'loginModal',
        },
      }),
    )
  }

  const sendFriendRequestCall = (people) => {
    if (user) {
      sendFriendRequest({
        variables: {
          friend_id: people?.id,
          user_id: user?.id,
          isActive: true,
          isFriend: true,
        },
      })
    } else {
      handleRedirect()
    }
  }

  return (
    <div className="fashionEnthusiasts-section">
      <div className="fashionEnthusiasts-back-alignment">
        <div
          className="back_details-alignment"
          onClick={() => {
            router.push('/fashion/women/', undefined, { scroll: false })
            dispatch(fetchApplianceCategory({ modal: '', isOpen: false, id: 0 }))
          }}
        >
          <div>
            <img src="/assets/icon/left-icon.svg" alt="back-page" />
          </div>
          <p>Woma...</p>
        </div>
        <div className="mobile-heading-alignment">
          <h4>Woman Fashio...</h4>
        </div>
      </div>
      <div className="fashionEnthusiasts-banner">
        <div className="fashionEnthusiasts-banner-img-alignment">
          <img src={FashionEnthusiastsBanner.src} alt="FashionEnthusiastsBanner" />
          <img
            src={MobileFashionEnthusiastsBanner.src}
            alt="MobileFashionEnthusiastsBanner"
            className="mobile-view-banner"
          />
        </div>
        <div className="container">
          <div className="fashionEnthusiasts-banner-section">
            <div
              className="left-arrow-alignment"
              onClick={() => {
                router.push('/fashion/women/', undefined, { scroll: false })
                dispatch(fetchApplianceCategory({ modal: '', isOpen: false, id: 0 }))
              }}
            >
              <img src="/assets/icon/leftArrow.svg" alt="left-arrow" />
            </div>
            <div className="fashionEnthusiasts-heading-alignment">
              <h4>Woman Fashion Influencers</h4>
              <p>{WOMEN_SECTION_TEXT.men_fashion_enthusiasts.text}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="fashionEnthusiasts-details-list-section">
        <div className="container">
          <div className="suggested-frieds-all-content-alignment">
            <div className="grid">
              {peopleData?.allPeople &&
                peopleData?.allPeople
                  ?.filter((usr) => usr.id !== user?.id)
                  ?.map((people, index) => {
                    return (
                      <AosAnimation animationType="fade-up" duration={1000} delay={index * 50}>
                        <PeopleItem
                          people={people}
                          declineFriendRequestCall={declineFriendRequestCall}
                          sendFriendRequestCall={sendFriendRequestCall}
                        />
                      </AosAnimation>
                    )
                  })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
